import { getCanonicalId } from './utils/authUtils';
import { getQueryParams } from './utils/utils';

function cleanseAttributeName(input) {
  // allowable characters retrieved from
  // eslint-disable-next-line max-len
  // https://docs.newrelic.com/docs/insights/insights-data-sources/custom-data/insights-custom-data-requirements-limits#general
  return input.replace(/[^a-zA-Z0-9_.:]/g, '_');
}

class NewRelicWrapper {
  constructor(NewRelic) {
    this.NewRelic = NewRelic;

    // Copied from Studio5 to provide more attributes in NR
    this.NewRelic.setCustomAttribute('metadata/href', window.location.href);
    const queryParams = getQueryParams();
    Object.keys(queryParams).forEach((param) => {
      if (param === 'selectedOptions') {
        Object.keys(queryParams[param]).forEach((option) => {
          this.NewRelic.setCustomAttribute(
            `param/selectedOptions/${cleanseAttributeName(option)}`,
            queryParams[param][option],
          );
        });
      } else {
        this.NewRelic.setCustomAttribute(`param/${cleanseAttributeName(param)}`, queryParams[param]);
      }
    });
    if (window.QuantumMetricAPI && window.QuantumMetricAPI.getReplay) {
      this.NewRelic.setCustomAttribute('QMReplayLink', window.QuantumMetricAPI.getReplay());
    } else {
      window.QuantumMetricOnload = () => {
        if (window.QuantumMetricAPI && window.QuantumMetricAPI.getReplay) {
          this.NewRelic.setCustomAttribute('QMReplayLink', window.QuantumMetricAPI.getReplay());
        }
      };
    }
  }

  updateCustomAttributes(otherAttributes) {
    this.NewRelic.setCustomAttribute('canonicalId', getCanonicalId());
    if (otherAttributes) {
      Object.keys(otherAttributes).forEach((param) => {
        this.NewRelic.setCustomAttribute(cleanseAttributeName(param), otherAttributes[param]);
      });
    }
  }

  noticeError(error) {
    this.updateCustomAttributes();
    this.NewRelic.noticeError(error);
  }
}

const NewRelic = window.newrelic || {
  noticeError() {
  },
};

const newRelicWrapper = new NewRelicWrapper(NewRelic);
export default newRelicWrapper;

export function logError(error) {
  // eslint-disable-next-line no-console
  console.log(error);

  const newRelicError = new Error(error);
  newRelicWrapper.noticeError(newRelicError);
}
